import React, { useEffect, useState } from 'react'
import DashboardPagesTemplate from '../../../components/DashboardPagesTemplate/DashboardPagesTemplate'
import AddBeneficiary from './AddBeneficiary'
import { BeneficiaryData, ColumnBeneficiary } from '../../../types/TablesTypes/beneficiary'
import client from '../../../api/client'
import showToast from '../../../components/CustomToast/toastHelper'
import moment from 'moment'
import { FaEllipsisH, FaTrash } from 'react-icons/fa'
import CustomModal from '../../../components/Modal/CustomModal'
import DeleteBeneficiary from './DeleteBeneficiary'

const Beneficiaries = () => {
  const [beneficiaries, setBeneficiaries] = useState<any>()
  const [tableRow, setTableRow] = useState<any[]>()
  const [showModal, setShowModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true);
  const [isExport, setIsExport] = useState<boolean>(false)
  const [isExportReady, setIsExportReady] = useState<boolean>(false);
  const [isExportLoading, setIsExportLoading] = useState<boolean>(false);
  const [openDeleteModal, setOpenDeleteModal] = useState<any>({value:false, id:0})
  const clickExport = async () => {
    setIsExport(true);
    setIsExportLoading(true)
    await fetchBeneficiaries();

    if (beneficiaries && beneficiaries.data.items?.length > 0) {
      setIsExportReady(true);
    }

    setIsExportLoading(false);
  };


  const handleShowModal = () => {
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      await fetchBeneficiaries();
      setLoading(false)
    };
    fetchData();
  }, [])
  const fetchBeneficiaries = async () => {
    try {
      const apiUrl = '/subsidiary/beneficiary/all';
      const response = await client.get(`${apiUrl}`);

      setBeneficiaries(response.data);
      const message = response?.data?.message;

    } catch (err: any) {
      if (err?.response?.data?.message === 'Please login again') {
        sessionStorage.clear();
        window.location.href = '/';
      } else {
        const message = err?.response?.data?.message;
        console.error('error getting data', err);
        showToast(message, "error");
      }
    }
    
  };

  const dataTransaction = () => {
    const tempArr: BeneficiaryData[] = [];
    beneficiaries?.data.items
      ?.slice(0)
      .reverse()
      .forEach((transaction: any, index: number) => {
        tempArr.push({
          name: transaction.name,
          type: transaction.type,
          recipient: transaction.accountNumber,
          date: moment(transaction?.dateCreated).format('DD MMM YYYY'),
          action: (
            <FaTrash color='green' onClick={()=>setOpenDeleteModal({value:true, id:transaction.id})} />
          ),
        });
      });

    return tempArr;
  };

  useEffect(() => {
    setTableRow(dataTransaction());
  }, [beneficiaries?.data.items]);
  return (
    <div>
      <DashboardPagesTemplate
        apiUrl=''
        show={showModal}
        openModal ={handleShowModal}
        closeModal ={handleCloseModal}
        dataToExport={beneficiaries?.data.items}
        onFilterChange={() => { }}
        data={tableRow ? tableRow : []}
        title='Beneficiaries'
        headings={ColumnBeneficiary}
        exportButtonExists={true}
        ctaButtonExists={true}
        buttonLabel='Add New Beneficiary'
        buttonIcon=''
        showSearch={false}
        filters={{}}
        dropdownItems={[]}
        datepickerExists={false}
        children={<AddBeneficiary onClose={handleCloseModal} onSuccess={fetchBeneficiaries} />}
        emptyMessage='You currently do not have any beneficiaries'
        loading={loading}
        clickExportButton={clickExport}
        exportButtonLoading={isExportLoading}
        exportButtonClicked={isExport}
      />
      <CustomModal dismissible show={openDeleteModal.value} position='center' children={<DeleteBeneficiary id={openDeleteModal.id} close={()=>{setOpenDeleteModal({...openDeleteModal,value:false}); fetchBeneficiaries()}}/>} size="sm" icon='' onClose={()=>setOpenDeleteModal(false)}/>
    </div>
  )
}

export default Beneficiaries
 